// Tab Management Functions
export default class TabManager {
  constructor() {
    this.init();
  }

  init() {
    // Make functions globally available for onclick handlers
    window.showMainTab = this.showMainTab.bind(this);
    window.showSubTab = this.showSubTab.bind(this);
    window.showTab = this.showTab.bind(this);
    window.toggleSummaryDetails = this.toggleSummaryDetails.bind(this);
  }

  // Main tab functionality
  showMainTab(tabName) {
    // Hide all main tab contents
    document.querySelectorAll('.main-tab-content').forEach(content => {
      content.classList.add('hidden');
    });

    // Remove active class from all main tab buttons
    document.querySelectorAll('.main-tab-button').forEach(button => {
      button.classList.remove('active', 'border-blue-500', 'text-blue-600');
      button.classList.add('border-transparent', 'text-gray-500');
    });

    // Show selected main tab content
    document.getElementById(tabName + '-main-content').classList.remove('hidden');

    // Add active class to selected main tab button
    const activeButton = document.getElementById(tabName + '-main-tab');
    activeButton.classList.add('active', 'border-blue-500', 'text-blue-600');
    activeButton.classList.remove('border-transparent', 'text-gray-500');
  }

  // Sub tab functionality (for transactions section)
  showSubTab(tabName) {
    // Hide all sub tab contents
    document.querySelectorAll('.sub-tab-content').forEach(content => {
      content.classList.add('hidden');
    });

    // Remove active class from all sub tab buttons
    document.querySelectorAll('.sub-tab-button').forEach(button => {
      button.classList.remove('active', 'border-blue-500', 'text-blue-600');
      button.classList.add('border-transparent', 'text-gray-500');
    });

    // Show selected sub tab content
    document.getElementById(tabName + '-content').classList.remove('hidden');

    // Add active class to selected sub tab button
    const activeButton = document.getElementById(tabName + '-tab');
    activeButton.classList.add('active', 'border-blue-500', 'text-blue-600');
    activeButton.classList.remove('border-transparent', 'text-gray-500');
  }

  // Legacy function for backward compatibility
  showTab(tabName) {
    this.showSubTab(tabName);
  }

  // Summary Details Card toggle functionality
  toggleSummaryDetails() {
    const collapsed = document.getElementById('summary-collapsed');
    const expanded = document.getElementById('summary-expanded');
    const toggleText = document.getElementById('toggle-text');
    const toggleIcon = document.getElementById('toggle-icon');

    const isExpanded = !expanded.classList.contains('hidden');

    if (isExpanded) {
      // Collapse the card
      expanded.classList.add('hidden');
      collapsed.classList.remove('hidden');
      toggleText.textContent = 'Show Details';
      toggleIcon.classList.remove('rotate-180');
    } else {
      // Expand the card
      collapsed.classList.add('hidden');
      expanded.classList.remove('hidden');
      toggleText.textContent = 'Hide Details';
      toggleIcon.classList.add('rotate-180');
    }
  }
}
